export enum CompanyStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
  Rejected = 'Rejected',
}

export enum AuthorisationType {
  DIRECTLY_AUTHORISED = 'Directly authorised',
  APPOINTED_REPRESENTATIVE = 'Appointed representative',
  PRINCIPAL_FIRM = 'Principal firm',
}

export type BrokerageSummary = {
  id: string,
  companyId: string,
  tradingCompanyName: string,
  fcaNumber: string,
  emailAddress: string,
  bdmAssigned: string,
  status: keyof typeof CompanyStatus,
  authorisationType: keyof typeof AuthorisationType;
  nextAnnualReviewDate: string,
}

export type Brokerages = {
  id: string,
  companies: BrokerageSummary[]
}

export type Address = {
  subBuilding: string;
  houseName: string;
  houseNumber: string;
  street: string;
  postTown: string;
  postCode: string;
};

export type CompanyDetails = {
  id: string;
  status: keyof typeof CompanyStatus;
  fcaNumber: string;
  tradingCompanyName: string;
  registeredCompanyName: string;
  telephoneNumber: string;
  emailAddress: string;
  webAddress: string;
  hasRegulatoryPermission: boolean;
  address: Address;
  authorisationType: keyof typeof AuthorisationType;
  icoNumber: string;
  companyRegistrationNumber: string;
  professionalIndemnity: string;
  levelOfCover: string;
};

export type PrincipalCompany = {
  id: string;
  fcaNumber: string;
  tradingCompanyName: string;
  registeredCompanyName: string;
  telephoneNumber: string;
  emailAddress: string;
  webAddress: string;
  hasRegulatoryPermission: boolean;
  address: Address;
  icoNumber: string;
  companyRegistrationNumber: string;
};

export type Notifications = {
  emailCaseOwner: boolean;
  additionalEmailAddresses: string[];
};

export type Representative = {
  id: string;
  fullName: string;
  position: string;
  director: boolean;
  shareholdingPct: number;
  appointedOn: string;
  resignedOn: string;
};

export type BankAccount = {
  id: string;
  bankAccountName: string;
  bankSortCode: string;
  bankAccountNumber: string;
};

export enum ClawbackFrequency {
  Unknown = 'Unknown',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
}

export type CommissionDetail = {
  id: string;
  type: string;
  displayName: string;
  commissionRate: number;
  commissionCap: number;
  clawbackPeriod: number;
  clawbackFrequency: keyof typeof ClawbackFrequency;
};

export type CommercialDetails = {
  id: string;
  commissionPaymentAccount: string;
  feePaymentAccount: string;
  commissionDetails: CommissionDetail[];
  isPackager: boolean;
  maxBrokerFee: number;
};

export type Brokerage = {
  id: string;
  searchesProfile: string;
  bdmAssigned: string;
  nextAnnualReviewDate: string;
  companyDetails: CompanyDetails;
  principalCompany: PrincipalCompany;
  notifications: Notifications;
  representatives: Representative[];
  bankAccounts: BankAccount[];
  commercialDetails: CommercialDetails;
  isPackager: boolean;
};
